export default __webpack_public_path__ + "static/graph_vertical-12043d0e74e0436908902833edba0e04.svg";